import currencies from 'lib/settings/currencies'

export function asCurrency(
  number: number,
  currency: Currency = 'USD',
  options: Partial<Intl.NumberFormatOptions> = {},
): string {
  let locale = ''
  switch (currency) {
    case 'USD':
      locale = 'en-US'
      break
    case 'CAD':
      locale = 'en-CA'
      break
    case 'EUR':
      locale = 'pt-PT'
      break
    case 'GBP':
      locale = 'en-GB'
      break
    case 'AUD':
      locale = 'en-AU'
      break
    case 'HKD':
      locale = 'zh-HK'
      break
    default:
      locale = 'en-US'
  }
  const numberWithCurrency = number.toLocaleString(locale, {
    style: 'currency',
    currencySign: 'accounting',
    currency,
    ...options,
  })

  return numberWithCurrency
}

/**
 * Format 3 segment phone number with first segment parenthesis
 *
 * Examples:
 *  123-456-7890 -> (123) 456-7890
 *
 * @param phoneNumber
 */
export function formatPhoneNumber(phoneNumber: string) {
  const cleaned = phoneNumber.replace(/\D/g, '')
  const regex = /^(\d{3})(\d{3})(\d{4})$/g

  const match = regex.exec(cleaned)

  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumber
}

/**
 * Get currecy symbol by code
 *
 * @param locale The locale of currency eg.
 * @param currency The currency CODE eg. USD, CAD etc.
 */
export function getCurrencySymbolByCode(locale: string, currency: Currency) {
  return (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim()
}

/**
 * Extract currecy symbol from string
 *
 * @param text The string that contains the currency symbol to be extract
 */
export function getCurrencySymbolFromString(text: string) {
  let extractedSymbol = ''
  currencies.forEach((currency) => {
    if (text.indexOf(getCurrencySymbolByCode('en-US', currency)) > 0) {
      const indexOfCurrency = text.indexOf(
        getCurrencySymbolByCode('en-US', currency),
      )
      extractedSymbol = text.substring(
        indexOfCurrency,
        indexOfCurrency + getCurrencySymbolByCode('en-US', currency).length,
      )
    }
  })
  return extractedSymbol
}

/**
 * Replace the currency symbol from string with selected currency code
 *
 * Examples:
 *  Up to $3,000 (additional) -> Up to €3,000 (additional)
 *
 * @param text The string that contains the currency symbol to be replace
 * @param selectedCurrency The code of selected currency
 */
export function replaceCurrencySignFromString(
  text: string,
  selectedCurrency: Currency,
): string {
  return text.replace(
    getCurrencySymbolFromString(text),
    getCurrencySymbolByCode('en-US', selectedCurrency),
  )
}
